import { Classes, Colors, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'src/components/icons/types';

export const Rule: React.VFC<IconProps> = ({
  className,
  color = Colors.GRAY1,
  iconSize = IconSize.STANDARD,
}) => (
  <svg
    className={classNames('sd-icon', Classes.ICON, className)}
    fill={color}
    height={iconSize}
    viewBox="0 0 20 20"
    width={iconSize}
  >
    <g clipPath="url(#clip0_328_94)">
      <path d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L2.08579 3.5L0.292893 5.29289C-0.097631 5.68342 -0.097631 6.31658 0.292893 6.70711C0.683417 7.09763 1.31658 7.09763 1.70711 6.70711L3.5 4.91421L5.29289 6.70711C5.68342 7.09763 6.31658 7.09763 6.70711 6.70711C7.09763 6.31658 7.09763 5.68342 6.70711 5.29289L4.91421 3.5L6.70711 1.70711C7.09763 1.31658 7.09763 0.683417 6.70711 0.292893C6.31658 -0.0976311 5.68342 -0.0976311 5.29289 0.292893L3.5 2.08579L1.70711 0.292893Z" />
      <path
        clipRule="evenodd"
        d="M16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20ZM16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
        fillRule="evenodd"
      />
      <path d="M18.29 5.7L16 3.41V8C16 9.65685 14.6569 11 13 11H4C3.44772 11 3 11.4477 3 12V19C3 19.5523 2.55228 20 2 20C1.44772 20 1 19.5523 1 19V12C1 10.3431 2.34315 9 4 9H13C13.5523 9 14 8.55228 14 8V3.41L11.71 5.71C11.53 5.89 11.28 6 11 6C10.45 6 10 5.55 10 5C10 4.72 10.11 4.47 10.29 4.29L14.29 0.29C14.47 0.11 14.72 1.49012e-08 15 1.49012e-08C15.28 1.49012e-08 15.53 0.11 15.71 0.29L19.71 4.29C19.89 4.47 20 4.72 20 5C20 5.55 19.55 6 19 6C18.72 6 18.47 5.89 18.29 5.7Z" />
    </g>
  </svg>
);
